import {Validators} from '../../../utils/validators';
import {FormModel} from '../../../components/Form';

export const SetPasswordForm = (strings: any): FormModel[] => {
  const passwordValidators = [{ check: Validators.validateMandatoryField }, { check: Validators.validatePassword }];

  return [
    {
      autoFocus: true,
      label: strings.new_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'password',
      validators: passwordValidators,
      sx: {mb: 2},
      responsive: {xs: 12},
      required: true,
    },
    {
      label: strings.confirm_password_text,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'password',
      variant: 'outlined',
      placeholder: '',
      field: 'confirmPassword',
      validators: passwordValidators,
      responsive: {xs: 12},
      required: true,
    },
  ];
};
